var map = {
	"./aashirvad-svasti.png": 137,
	"./aashirvad.png": 138,
	"./amul.png": 139,
	"./cadbury.svg": 140,
	"./coca-cola.svg": 141,
	"./colgate.png": 142,
	"./daawat.png": 143,
	"./dabur.png": 144,
	"./dettol.jpg": 145,
	"./fortune.png": 146,
	"./haldirams.png": 147,
	"./j.png": 148,
	"./osam.jpg": 149,
	"./pepsi.svg": 150,
	"./sudha.png": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;